import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class CustomsTarifService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 1725
     * @datataskName sp_ws_p2_customstarif_list
     * @returns promise containing list of custom tarifs.
     */
    public getCustomsTarifs(): Promise<CustomsTarifItem[]> {
        return this.datatask.Post(1725);
    }
}

export interface CustomsTarifItem {
    customstarif_id: string;
    customstarif_name: string;
    orderby: string;
}
